var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { isEmpty, keys } from "ramda";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import uuid from "uuid/v1";
import CountrySelect from "../common/CountrySelect";
import EnterpriseSelect from "../common/EnterpriseSelect";
import InputField from "../common/InputField";
import RoleSelect from "../common/RoleSelect";
var validate = function (user, role) {
    var errors = {};
    if (isEmpty(user.firstName)) {
        errors.firstName = "You must provide a value";
    }
    if (isEmpty(user.lastName)) {
        errors.lastName = "You must provide a value";
    }
    if (isEmpty(user.company)) {
        errors.company = "You must provide a value";
    }
    if (isEmpty(user.address)) {
        errors.address = "You must provide a value";
    }
    if (isEmpty(user.city)) {
        errors.city = "You must provide a value";
    }
    if (isEmpty(user.postalCode) && user.country === "DE") {
        errors.postalCode = "You must provide a value";
    }
    if (isEmpty(user.enterprises)) {
        errors.enterprises = "User must be associated with an enterprise";
    }
    if (!user.email) {
        errors.email = "Required";
    }
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(user.email)) {
        errors.email = "Invalid email address";
    }
    return errors;
};
var AgentForm = function (props) {
    var _a = useState(props.lastUser || {
        id: uuid(),
        role: "agent",
        email: "",
        company: "",
        firstName: "",
        lastName: "",
        phone: "",
        country: "DE",
        address: "",
        city: "",
        postalCode: "",
        enterprises: [],
        created: new Date(),
        updated: new Date(),
    }), user = _a[0], setUser = _a[1];
    var updateUser = function () {
        props.checkUser(user);
    };
    var errors = validate(user, props.currentUser.role);
    var remaining = function (key) {
        var ents = props.enterprises.filter(function (en) { return user.enterprises.findIndex(function (ent, i) { return ent === en.id && i !== key; }) === -1; });
        return ents;
    };
    var enterpriseSelectors = user.enterprises.map(function (e, key) {
        return (React.createElement(EnterpriseSelect, { key: key, value: e, enterprises: remaining(key), setEnterprise: function (id) {
                var enterprises = __spreadArrays(user.enterprises);
                if (id !== "none") {
                    enterprises[key] = id;
                }
                else {
                    enterprises.splice(key, 1);
                }
                setUser(function () { return (__assign(__assign({}, user), { enterprises: enterprises })); });
            }, error: key === 0 ? errors.enterprises : undefined }));
    });
    if (user.enterprises.length < props.enterprises.length) {
        enterpriseSelectors.push(React.createElement(EnterpriseSelect, { key: "new", value: "none", enterprises: remaining(-1), setEnterprise: function (id) {
                var enterprises = __spreadArrays(user.enterprises);
                enterprises.push(id);
                setUser(function () { return (__assign(__assign({}, user), { enterprises: enterprises })); });
            }, error: enterpriseSelectors.length === 0 ? errors.enterprises : undefined }));
    }
    return (React.createElement("div", { className: "container content" },
        React.createElement("h5", null, "Create Agent or Admin"),
        React.createElement("br", null),
        React.createElement("form", { onSubmit: function (e) {
                e.preventDefault();
            } },
            React.createElement("div", { className: "card-panel" },
                React.createElement(InputField, { label: "Email", type: "email", placeholder: "", meta: { touched: props.currentUser.email !== user.email, error: errors.email }, onChange: function (email) { return setUser(__assign(__assign({}, user), { email: email })); }, value: user.email }),
                React.createElement(InputField, { label: "First name", type: "text", placeholder: "", meta: { touched: props.currentUser.firstName !== user.firstName, error: errors.firstName }, onChange: function (firstName) { return setUser(__assign(__assign({}, user), { firstName: firstName })); }, value: user.firstName }),
                React.createElement(InputField, { label: "Last name", type: "text", placeholder: "", meta: { touched: props.currentUser.lastName !== user.lastName, error: errors.lastName }, onChange: function (lastName) { return setUser(__assign(__assign({}, user), { lastName: lastName })); }, value: user.lastName }),
                React.createElement(InputField, { label: "Company", type: "text", placeholder: "", meta: { touched: props.currentUser.company !== user.company, error: errors.company }, onChange: function (company) { return setUser(__assign(__assign({}, user), { company: company })); }, value: user.company }),
                enterpriseSelectors),
            React.createElement("div", { className: "card-panel" },
                React.createElement(InputField, { label: "Address", type: "text", placeholder: "", meta: { touched: props.currentUser.address !== user.address, error: errors.address }, onChange: function (address) { return setUser(__assign(__assign({}, user), { address: address })); }, value: user.address }),
                React.createElement(InputField, { label: "City", type: "text", placeholder: "", meta: { touched: props.currentUser.city !== user.city, error: errors.city }, onChange: function (city) { return setUser(__assign(__assign({}, user), { city: city })); }, value: user.city }),
                user.country === "DE" && (React.createElement(InputField, { label: "Postal code", type: "text", placeholder: "", meta: {
                        touched: props.currentUser.postalCode !== user.postalCode,
                        error: errors.postalCode,
                    }, onChange: function (postalCode) { return setUser(__assign(__assign({}, user), { postalCode: postalCode })); }, value: user.postalCode })),
                React.createElement("div", null,
                    React.createElement(CountrySelect, { value: user.country, onChange: function (e) { return setUser(__assign(__assign({}, user), { country: e.target.value })); }, enterprises: props.enterprises }),
                    React.createElement(RoleSelect, { allowance: props.currentUser.role, value: user.role, onChange: function (e) { return setUser(__assign(__assign({}, user), { role: e.target.value })); }, meta: { touched: true, error: errors.role } })),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(Link, { to: "/users", className: "white btn-flat left red-text" }, "Cancel"),
                React.createElement("button", { className: "teal btn-flat btn right white-text", onClick: function () { return updateUser(); }, disabled: keys(errors).length > 0 }, "Next"),
                React.createElement("br", null),
                React.createElement("br", null)))));
};
export default AgentForm;



//////////////////
// WEBPACK FOOTER
// ./src/components/users/AgentForm.tsx
// module id = 1224
// module chunks = 0